import DomainService from '@/services/domain.service'
import ISearchDomainResponse from '@/types/response/search-domain.response.interface'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const fetchDomain = createAsyncThunk<ISearchDomainResponse, { domainName: string }>(
  'domain/searchDomain',
  async ({ domainName }) => {
    const data = await DomainService.searchDomain({ domainName })

    return data
  }
)
